import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Reveal } from '../../shared/reveal';
import { Seo } from '../../core/seo';
import { breadcrumbLd } from '../../core/structured-data';

@Component({
  selector: 'app-about',
  imports: [RouterLink, Reveal],
  templateUrl: './about.html',
  styleUrl: './about.scss'
})
export class About implements OnInit {
  private readonly seo = inject(Seo);

  readonly facts = [
    { label: 'Legal name',   value: 'Mechtron Technical Services Private Limited' },
    { label: 'Constitution', value: 'Private Limited Company' },
    { label: 'GST',          value: '27AATCM9449D1ZU' },
    { label: 'Registered',   value: '14 October 2025, Maharashtra' },
    { label: 'Team',         value: '11–25 people' },
    { label: 'Jurisdiction', value: 'Virar East, Palghar' }
  ];

  ngOnInit(): void {
    this.seo.apply({
      title: 'About Mechtron Water Services | Waste Water Engineering, Maharashtra',
      description:
        'Mechtron Technical Services Private Limited designs and manufactures waste water ' +
        'treatment plants and equipment in Vasai Virar, Maharashtra, with an in-house workshop ' +
        'and calibration laboratory.',
      path: '/about'
    });
    this.seo.setJsonLd('ld-breadcrumb', breadcrumbLd([
      { name: 'Home', path: '/' },
      { name: 'About', path: '/about' }
    ]));
  }
}
